module.exports = __webpack_public_path__ + "static/hf3-5-3726411b1f91d80223432d93644cdeda.gif";